import {
  Component,
  Input,
  OnInit,
  ViewEncapsulation,
  OnDestroy,
  ViewContainerRef,
  ViewChild,
} from "@angular/core";
import { SubSink } from "subsink";

import { ConfigurationService } from "@/shared-module/services";
import { Configuration, ProgressBarDatasource } from "@/shared-module/models";

@Component({
  selector: "app-progressbar",
  templateUrl: "progressbar.component.html",
  encapsulation: ViewEncapsulation.None,
})
export class ProgressBarComponent implements OnInit, OnDestroy {
  @ViewChild("template", { static: true }) template;
  source: ProgressBarDatasource;

  @Input("data") set setdata(data: ProgressBarDatasource) {
    this.source = data;
    this.calculateFactor();
  }
  @Input("dynamicValue") set setdynamicValue(data: number) {
    this.source.bar2Value = data;
    this.calculateFactor();
  }
  @Input("baseValue") set setbaseValue(data: number) {
    this.source.bar1Value = data;
    this.calculateFactor();
  }

  subs = new SubSink();
  rgbColor: string;
  value1: string;
  value2: string;
  value1Text: string;
  value2Text: string;

  constructor(
    private configurationService: ConfigurationService,
    private viewContainerRef: ViewContainerRef,
  ) {
    const thisObject = this;
    this.subs.sink = this.configurationService.config.subscribe(
      (c: Configuration) => {
        thisObject.rgbColor = c.rgb;
      },
    );
  }

  ngOnInit() {
    this.viewContainerRef.createEmbeddedView(this.template);
    this.calculateFactor();
  }

  getvalue1() {
    return this.value1;
  }
  getvalue2() {
    return this.value2;
  }

  calculateFactor() {
    let factor = 1;
    if (this.source) {
      if (this.source.bar1Value && this.source.bar2Value) {
        const maxValue = Math.max(this.source.bar1Value, this.source.bar2Value);
        if (maxValue < 2) {
          factor = 50;
        } else if (maxValue < 5) {
          factor = 20;
        } else if (maxValue < 10) {
          factor = 10;
        } else if (maxValue < 20) {
          factor = 5;
        } else if (maxValue < 50) {
          factor = 2;
        } else if (maxValue < 100) {
          factor = 1;
        } else if (maxValue < 200) {
          factor = 0.5;
        } else if (maxValue < 500) {
          factor = 0.2;
        } else if (maxValue < 1000) {
          factor = 0.1;
        } else if (maxValue < 2000) {
          factor = 0.05;
        } else if (maxValue < 5000) {
          factor = 0.02;
        }

        this.value1 = this.source.bar1Value * factor + "%";
        this.value2 = this.source.bar2Value * factor + "%";

        this.value1Text = (
          Math.round(this.source.bar1Value * 100) / 100
        ).toString();
        this.value2Text = (
          Math.floor(this.source.bar2Value * 100) / 100
        ).toString();

        if (this.source.bar1Value !== 0) {
          const changeValue =
            (this.source.bar2Value - this.source.bar1Value) /
            this.source.bar1Value;
          const change = Math.round(changeValue * 100) + "%";
          if (changeValue > 0) {
            this.value2Text += " (+" + change + ")";
          } else if (changeValue < 0) {
            this.value2Text += " (" + change + ")";
          }
        }
      }
    }
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}
